import { useQuery } from "@tanstack/solid-query"
import { createFileRoute } from "@tanstack/solid-router"
import { Button } from "~/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card"
import { Col, Grid } from "~/components/ui/grid"
import { TextField, TextFieldInput, TextFieldLabel } from "~/components/ui/text-field"
import { orpc } from "~/lib/orpc"
import { OfficersCard } from "./-components/OfficersCard"
import { SuspectsCard } from "./-components/SuspectsCard"
import { TextEditor } from "./-components/TextEditor"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/cases/$caseId/")({
  loader: async ({ context, params }) => {
    const data = await context.queryClient.ensureQueryData(
      orpc.tablet.cases.get.queryOptions({ input: { caseId: params.caseId } })
    )

    return { crumb: data.name }
  },
  component: RouteComponent
})

function RouteComponent() {
  const params = Route.useParams()

  const caseQuery = useQuery(() =>
    orpc.tablet.cases.get.queryOptions({
      input: {
        caseId: params().caseId
      }
    })
  )

  return (
    <Grid cols={4} class="gap-2">
      <Col span={3} class="flex flex-col gap-2">
        <TextEditor />
        <SuspectsCard />
        <OfficersCard />
      </Col>
      <Col>
        <Card>
          <CardHeader class="flex-row items-center justify-between space-y-0">
            <CardTitle>Case Status</CardTitle>
            <Button variant="outline" class="h-8">
              Save Changes
            </Button>
          </CardHeader>
          <CardContent>
            <div class="flex flex-col gap-2">
              <TextField>
                <TextFieldLabel>Name</TextFieldLabel>
                <TextFieldInput />
              </TextField>
              <TextField>
                <TextFieldLabel>Name</TextFieldLabel>
                <TextFieldInput />
              </TextField>
              <TextField>
                <TextFieldLabel>Name</TextFieldLabel>
                <TextFieldInput />
              </TextField>
            </div>
          </CardContent>
        </Card>
      </Col>
    </Grid>
  )
}
